import React from 'react'
import { Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWarning } from '@fortawesome/pro-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

import styles from './WarningModal.module.scss'

interface WarningModalProps {
  show: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  width?: number
  className?: string
  footer?: React.ReactNode | null
}

export const WarningModal: React.FC<WarningModalProps> = ({
  show,
  onClose,
  title,
  children,
  width = 800,
  className = '',
  footer = null,
}) => {
  return (
    <Modal
      visible={show}
      onCancel={onClose}
      centered
      width={width}
      footer={footer}
      closable={false}
      className={`${styles.root} ${className}`}
      title={
        <div className={styles.header}>
          <FontAwesomeIcon icon={faWarning as IconProp} />
          <h5 className="ml-2 mb-0">{title}</h5>
        </div>
      }
    >
      {children}
    </Modal>
  )
}

export default WarningModal
